import { Box, Checkbox, List, Text } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Settings from 'modules/employee_onboarding/components/TasksList/Task/Settings'
import { ActionConfigurationIdentifiers, MaterializedItem } from 'modules/processes/domain'
import questionGroups from 'modules/surveys/store/collections/questionGroups'
import surveys from 'modules/surveys/store/collections/v2/surveys'

interface Props {
  setActionsLoading: (value: Record<string, boolean>) => void
  setActionsCompletedNumber: (value: number) => void
  isFiltering: boolean
  items: MaterializedItem[]
}

export const SurveyList = ({
  setActionsLoading,
  setActionsCompletedNumber,
  isFiltering,
  items,
}: Props) => {
  const { navigation } = useNavigation()
  const { value, loading } = useAsyncData(async () => {
    await surveys.fetch()
    await questionGroups.fetch()

    const currentSurveys = surveys.models
    const currentSurveysIds = currentSurveys.map((survey) => survey.attributes.id)

    const filteredItems = items.filter(
      (item) => item.actionIdentifier === ActionConfigurationIdentifiers.SendSurvey
    )

    const values = questionGroups.models
      .filter((questionGroup) => {
        return currentSurveysIds.includes(questionGroup.attributes.surveys_form_id)
      })
      .flatMap((questionGroup) => {
        const currentSurvey = currentSurveys.find(
          (survey) => survey.attributes.id === questionGroup.attributes.surveys_form_id
        )

        const relatedItem = filteredItems.find((item) => {
          const surveyIdFromItem = JSON.parse(item.item?.action?.configuration || '{}').survey_id
          return String(surveyIdFromItem) === currentSurvey?.attributes.id
        })

        if (!relatedItem) {
          return []
        }

        return {
          survey_name: currentSurvey?.attributes.name,
          survey_id: currentSurvey?.attributes.id,
          answered: !!questionGroup.attributes.answered_at,
          id: questionGroup.attributes.id,
        }
      })

    setActionsCompletedNumber(values.filter((group) => group.answered).length)

    return values
  }, [])

  useEffect(() => {
    setActionsLoading({ surveys: loading })
  }, [loading])

  if (!items.length) {
    return <></>
  }

  return !isFiltering ? (
    <>
      {value?.map((group) => {
        return (
          <List.Item key={group.id}>
            <List.Title>
              <Box flexDirection="row" gap="s24" paddingY="s16">
                <Checkbox checked={group.answered} size="large" disabled onChange={() => {}} />
                <Box flexDirection="column" gap="s4">
                  <Text.Normal color="grey1000" weight="medium" stroked={group.answered}>
                    {i18n.t('employees.onboarding_task.actions.surveys.pending', {
                      name: group.survey_name,
                    })}
                  </Text.Normal>
                </Box>
              </Box>
            </List.Title>
            <List.Description>
              <Box flexDirection="row" gap="s24" alignItems="center">
                <Settings
                  route={
                    group.answered
                      ? navigation.engagement.surveys.id.responses.questionGroupId.fullPath({
                          id: String(group.survey_id),
                          question_group_id: String(group.id),
                        })
                      : navigation.engagement.surveys.id.answer.fullPath({
                          id: String(group.survey_id),
                        })
                  }
                />
              </Box>
            </List.Description>
          </List.Item>
        )
      })}
    </>
  ) : (
    <></>
  )
}
